module.exports = "/404/images/mountains-back.png";